import React, { useEffect, useState } from 'react';
import { Clock, Check, ArrowRight, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-157">
      <div className="text-center mb-12" data-id="element-158">
        <div className="inline-flex items-center bg-coral-50 text-coral-600 font-bold px-6 py-2 rounded-full border border-coral-200 mb-6" data-id="element-159">
          <Clock className="w-5 h-5 mr-2" data-id="element-160" />⏰ PRECIO DE LANZAMIENTO — OFERTA
          POR TIEMPO LIMITADO
        </div>

        <div className="flex justify-center items-center gap-4 text-4xl md:text-5xl font-black text-stone-900 mb-4" data-id="element-161">
          <div className="bg-white px-4 py-2 rounded-xl border border-stone-200 shadow-sm" data-id="element-162">
            {String(timeLeft.h).padStart(2, '0')}{' '}
            <span className="text-sm text-stone-500 block" data-id="element-163">HS</span>
          </div>
          <span className="text-stone-300" data-id="element-164">:</span>
          <div className="bg-white px-4 py-2 rounded-xl border border-stone-200 shadow-sm" data-id="element-165">
            {String(timeLeft.m).padStart(2, '0')}{' '}
            <span className="text-sm text-stone-500 block" data-id="element-166">MIN</span>
          </div>
          <span className="text-stone-300" data-id="element-167">:</span>
          <div className="bg-white px-4 py-2 rounded-xl border border-stone-200 shadow-sm" data-id="element-168">
            {String(timeLeft.s).padStart(2, '0')}{' '}
            <span className="text-sm text-stone-500 block" data-id="element-169">SEG</span>
          </div>
        </div>

        <p className="text-coral-500 font-medium" data-id="element-170">
          🔴 El precio sube cuando termina el contador
        </p>
      </div>

      {/* White card wrapping the full checkout block */}
      <div className="bg-white rounded-3xl shadow-xl border border-stone-100 max-w-2xl mx-auto p-6 md:p-10" data-id="element-171">
        <div className="text-center mb-8" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-3" data-id="element-173">
            Elegí tu Pack:
          </h2>
          <p className="text-stone-500 text-base md:text-lg" data-id="element-174">
            Ambas opciones incluyen los 6 Bonus estratégicos
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-175">
          {/* Pack Profesional — unselected row */}
          <a href="https://profelisto.com.ar/checkouts/cn/hWNCundd8M9axaT6zlLMthGk/es-ar?_r=AQABJSXFnQ5rzLjTHa-Ovar2Tb8gzCFau8Kk4A7eradlUlU" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('profesional')} className="flex items-center gap-3 sm:gap-4 bg-white rounded-2xl border-2 border-stone-200 pl-4 pr-5 sm:pl-5 sm:pr-8 py-5 cursor-pointer hover:border-stone-300 transition-colors" data-id="element-176">
            <span className="w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 border-stone-300 flex-shrink-0" data-id="element-177" />
            <div className="flex-1 flex items-center gap-2 sm:gap-3 min-w-0" data-id="element-178">
              <span className="text-2xl sm:text-3xl" data-id="element-179">📘</span>
              <div className="min-w-0" data-id="element-180">
                <p className="font-extrabold text-stone-900 text-sm sm:text-base md:text-lg leading-tight" data-id="element-181">
                  PACK PROFESIONAL
                </p>
                <p className="text-stone-500 text-xs sm:text-sm mt-1" data-id="element-182">
                  12 Tomos + 6 Bonus
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0 leading-none pr-1" data-id="element-183">
              <p className="text-stone-400 line-through text-xs sm:text-sm mb-2" data-id="element-184">
                $29.990
              </p>
              <p className="text-stone-900 font-extrabold text-lg sm:text-xl md:text-2xl leading-tight whitespace-nowrap" data-id="element-185">
                $18.990
              </p>
            </div>
          </a>

          {/* Megapack Elite — selected row */}
          <a href="https://profelisto.com.ar/checkouts/cn/hWNCundsEzMD13gRGTWKzhBK/es-ar?_r=AQAB2RFJbU3lvfIp-j8gGod7Q4YeFh_U04Ydq24-5S8PkwE" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('elite')} className="flex items-start gap-3 sm:gap-4 bg-coral-50 rounded-2xl border-2 border-coral-500 pl-4 pr-5 sm:pl-5 sm:pr-8 py-5 cursor-pointer shadow-sm hover:bg-coral-100 transition-colors" data-id="element-186">
            <span className="w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 border-coral-500 flex-shrink-0 flex items-center justify-center mt-1" data-id="element-187">
              <span className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-coral-500" data-id="element-188" />
            </span>
            <div className="flex-1 min-w-0" data-id="element-189">
              <div className="flex items-start gap-2 mb-2" data-id="element-190">
                <span className="text-xl sm:text-2xl" data-id="element-191">🏆</span>
                <p className="font-extrabold text-stone-900 text-sm sm:text-base md:text-lg leading-tight" data-id="element-192">
                  MEGAPACK ÉLITE
                </p>
              </div>
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-193">
                <span className="inline-flex items-center bg-amber-400 text-amber-900 font-bold text-[10px] sm:text-[11px] px-2.5 sm:px-3 py-1 rounded-full" data-id="element-194">
                  ⭐ MÁS ELEGIDO
                </span>
                <span className="inline-flex items-center bg-coral-100 text-coral-700 font-bold text-[10px] sm:text-[11px] px-2.5 sm:px-3 py-1 rounded-full" data-id="element-195">
                  AHORRÁS $10.000
                </span>
              </div>
              <p className="text-stone-600 text-xs sm:text-sm leading-snug" data-id="element-196">
                12 Tomos + 6 Bonus +{' '}
                <span className="font-bold text-stone-900" data-id="element-197">2 EBOOKS ÉLITE</span>
              </p>
            </div>
            <div className="text-right flex-shrink-0 leading-none pr-1" data-id="element-198">
              <p className="text-stone-400 line-through text-xs sm:text-sm mb-2" data-id="element-199">
                $49.990
              </p>
              <p className="text-coral-500 font-extrabold text-lg sm:text-xl md:text-2xl leading-tight whitespace-nowrap" data-id="element-200">
                $27.990
              </p>
            </div>
          </a>
        </div>

        {/* Main CTA */}
        <a href="https://profelisto.com.ar/checkouts/cn/hWNCundsEzMD13gRGTWKzhBK/es-ar?_r=AQAB2RFJbU3lvfIp-j8gGod7Q4YeFh_U04Ydq24-5S8PkwE" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('elite')} className="w-full py-5 px-6 rounded-2xl bg-coral-500 hover:bg-coral-600 text-white font-extrabold text-base md:text-lg transition-colors flex flex-col justify-center items-center shadow-lg shadow-coral-500/30" data-id="element-201">
          <span className="flex items-center" data-id="element-202">
            SÍ, QUIERO EL MEGAPACK ÉLITE
          </span>
          <ArrowRight className="w-5 h-5 mt-1" data-id="element-203" />
        </a>
        <p className="text-center text-sm text-stone-500 italic mt-5" data-id="element-204">
          La opción más elegida por profesores de funcional argentinos
        </p>
      </div>

      {/* Trust badges OUTSIDE the white card */}
      <div className="max-w-2xl mx-auto mt-8 grid grid-cols-2 gap-x-6 gap-y-4 text-sm text-stone-600 px-4" data-id="element-205">
        <span className="flex items-center" data-id="element-206">
          <Lock className="w-4 h-4 mr-2 text-stone-400" data-id="element-207" /> Pago seguro
        </span>
        <span className="flex items-center" data-id="element-208">
          <Zap className="w-4 h-4 mr-2 text-amber-500" data-id="element-209" /> Acceso en 5 min
        </span>
        <span className="flex items-center" data-id="element-210">
          <Shield className="w-4 h-4 mr-2 text-emerald-600" data-id="element-211" /> Garantía 7 días
        </span>
        <span className="flex items-center" data-id="element-212">
          <CreditCard className="w-4 h-4 mr-2 text-stone-400" data-id="element-213" /> Tarjeta ·
          Transferencia
        </span>
      </div>
    </section>;
}
export function EliteSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-stone-50 border-y border-stone-200" data-id="element-214">
      <div className="max-w-4xl mx-auto" data-id="element-215">
        <div className="text-center mb-12" data-id="element-216">
          <h2 className="text-3xl font-bold text-stone-900 mb-4" data-id="element-217">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-xl text-coral-600 font-medium" data-id="element-218">
            Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
          </p>
        </div>

        <div className="space-y-6" data-id="element-219">
          <div className="bg-white p-8 rounded-2xl border border-stone-200 shadow-sm" data-id="element-220">
            <h3 className="text-xl font-bold text-stone-900 mb-4 flex items-center" data-id="element-221">
              <span className="mr-3 text-2xl" data-id="element-222">📖</span> Élite 1 — El Diccionario
              de Variantes
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-223">
              Más de 500 regresiones y progresiones para adaptar cualquier
              ejercicio a cualquier nivel en 1 segundo. ¿Un alumno no puede
              hacer una estocada? ¿Otro ya superó el peso disponible? Acá está
              la respuesta instantánea para cada caso sin cortar el ritmo de la
              clase.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-stone-200 shadow-sm" data-id="element-224">
            <h3 className="text-xl font-bold text-stone-900 mb-4 flex items-center" data-id="element-225">
              <span className="mr-3 text-2xl" data-id="element-226">🛡️</span> Élite 2 — Biomecánica
              Avanzada: El Manual de las Patologías
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-227">
              Tu seguro de vida profesional. Adaptá las clases de Funcional 360
              para alumnos con hernias, lesiones de rodilla, problemas de hombro
              e hipertensión arterial. Entrená cuerpos reales con respaldo
              técnico y sin miedo a generar una lesión.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
export function ComparisonTable() {
  const comparisons = [{
    without: 'Horas planificando desde cero cada semana',
    with: '5 minutos. Todo listo.'
  }, {
    without: 'Clases improvisadas sin progresión real de cargas',
    with: '+120 clases graficadas por nivel'
  }, {
    without: 'Grupos sin sistema claro de avance ni benchmarks',
    with: 'Estructura clara para cada nivel y objetivo'
  }, {
    without: 'Miedo a que un alumno se lesione por mala técnica o carga excesiva',
    with: '500 variantes listas y manual de patologías incluido'
  }, {
    without: 'Alumnos que se estancan y se van al gimnasio de enfrente',
    with: 'Progresión visible que fideliza y retiene'
  }, {
    without: 'Vos sin tiempo para entrenar porque planificás todo el día',
    with: 'Tus rutinas incluidas en el WOD del Profe'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-228">
      <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-229">
        ¿Cuánto cuesta NO tenerlo?
      </h2>

      <div className="overflow-x-auto rounded-2xl shadow-sm border border-stone-200" data-id="element-230">
        <table className="w-full text-left border-collapse bg-white" data-id="element-231">
          <thead data-id="element-232">
            <tr data-id="element-233">
              <th className="p-5 bg-stone-100 text-stone-600 font-bold w-1/2 border-b border-stone-200" data-id="element-234">
                Sin FUNCIONAL 360
              </th>
              <th className="p-5 bg-coral-50 text-coral-600 font-bold w-1/2 border-b border-coral-100" data-id="element-235">
                Con FUNCIONAL 360
              </th>
            </tr>
          </thead>
          <tbody data-id="element-236">
            {comparisons.map((row, i) => <tr key={i} className="border-b border-stone-100 last:border-0" data-id="element-237">
                <td className="p-5 text-stone-600 bg-white" data-id="element-238">{row.without}</td>
                <td className="p-5 text-stone-900 font-medium bg-coral-50/30 flex items-start" data-id="element-239">
                  <ArrowRight className="w-5 h-5 text-coral-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-240" />
                  {row.with}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="text-center text-xl font-bold text-stone-900 mt-12 italic" data-id="element-241">
        El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
      </p>
    </section>;
}